import { Switch } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik, useFormikContext } from "formik";
import { EyeSlashIcon, EyeIcon } from "@heroicons/react/24/outline";
import md5 from "js-md5";

const NuevoPassword = ({
  handleContinuar,
  datosRevisionCuenta,
  handleAtras,
  handleClick,
}) => {
  const { values, errors, resetForm } = useFormikContext();
  const [showPswd1, setShowPswd1] = useState(false);
  const [showPswd2, setShowPswd2] = useState(false);

  const togglePswd1 = () => {
    return setShowPswd1(!showPswd1);
  };

  const togglePswd2 = () => {
    return setShowPswd2(!showPswd2);
  };

  return (
    <>
      <div className="text-center w-full">
        <p className="font-semibold text-white text-base w-full">
          Por favor ingresa la nueva contraseña en los cuadros de texto
          siguiente
        </p>

        <div className="py-1 text-left flex-col w-full">
          <label className="text-white">Nueva contraseña</label>

          <div className="flex flex-row bg-white rounded-md">
            <Field
              name="nuevaClave"
              type={showPswd1 ? "text" : "password"}
              className={"flex w-full items-center border-gray-300 focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm rounded-l-lg"}
            ></Field>
            <div className="ml-2 mr-2 mt-1 hover:text-secundario">
            {showPswd1 ? (
              <EyeSlashIcon
                className=" w-6 h-6"
                onClick={()=>togglePswd1()}
              />
            ) : (
              <EyeIcon className=" w-6 h-6" onClick={()=>togglePswd1()} />
            )}
            </div>
          </div>
          {errors?.nuevaClave && (
            <div className=" text-sm font-medium text-secundario my-2">
              {errors?.nuevaClave}
            </div>
          )}

          <label className="text-white mb-2 rounded-md flex">
            Confirmación nueva contraseña
          </label>

          <div className="flex flex-row bg-white rounded-md">
            <Field
              name="nuevaClave2"
              type={showPswd2 ? "text" : "password"}
              className={
                "flex  w-full items-center  border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm rounded-l-lg"
              }
            ></Field>
            <div className="ml-2 mr-2 mt-1 hover:text-secundario">
            {showPswd2 ? (
              <EyeSlashIcon
                className="w-6 h-6 "
                onClick={()=>togglePswd2()}
              />
            ) : (
              <EyeIcon className="w-6 h-6 "
              onClick={()=>togglePswd2()} />
            )}
            </div>
          </div>

          {errors?.nuevaClave2 && (
            <div className=" text-sm font-medium text-secundario my-2">
              {errors?.nuevaClave2}
            </div>
          )}
        </div>

        <div className="flex flex-row gap-2">
          <button
            className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
            type="button"
            name="passStep3"
            onClick={(e) => {
              handleAtras(e.target);
              resetForm();
            }}
          >
            Atrás
          </button>
          <button
            className="w-full mt-4 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
            type="button"
            onClick={() => {
              handleClick(values, errors, resetForm);
            }}
          >
            Finalizar
          </button>
        </div>
      </div>
    </>
  );
};

export default NuevoPassword;
